import Tooltip from '@mui/material/Tooltip';

import { useTranslate } from 'src/locales';

import Label from 'src/components/label';
import Iconify from 'src/components/iconify';

import { formatDate } from '../utils';

// ----------------------------------------------------------------------

type Props = {
  doNotCall?: boolean | null;
  since?: string | null;
};

/** JT1-1827: the person asked not to be called. Shown on their profile wherever they appear. */
export default function DoNotCallChip({ doNotCall, since }: Props) {
  const { t } = useTranslate();
  if (!doNotCall) return null;

  const chip = (
    <Label variant="soft" color="error" startIcon={<Iconify icon="solar:forbidden-circle-bold" />} data-testid="do-not-call-chip">
      {t('call_lists.do_not_call')}
    </Label>
  );

  return since ? <Tooltip title={t('call_lists.dnc.since', { date: formatDate(since) })}>{chip}</Tooltip> : chip;
}
